import React, { Component } from "react";

class SectionVirtualOffice extends Component {
  render() {
    return (
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-35b59fed elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="35b59fed"
        data-element_type="section"
        data-settings='{"shape_divider_top":"opacity-tilt"}'
      >
        <div
          className="elementor-shape elementor-shape-top"
          data-negative="false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 2600 131.1"
            preserveAspectRatio="none"
          >
            <path
              className="elementor-shape-fill"
              d="M0 0L2600 0 2600 69.1 0 0z"
            />
            <path
              className="elementor-shape-fill"
              style={{ opacity: 0.5 }}
              d="M0 0L2600 0 2600 69.1 0 69.1z"
            />
            <path
              className="elementor-shape-fill"
              style={{ opacity: 0.25 }}
              d="M2600 0L0 0 0 130.1 2600 69.1z"
            />
          </svg>{" "}
        </div>
        <div className="elementor-container elementor-column-gap-default">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-677f1717"
            data-id="677f1717"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-508a71f8 elementor-widget elementor-widget-image"
                data-id="508a71f8"
                data-element_type="widget"
                data-widget_type="image.default"
              >
                <div className="elementor-widget-container">
                  <img
                    loading="lazy"
                    decoding="async"
                    width="800"
                    height="450"
                    src="https://cdn.sigmobi.com/assets/uploads/2024/11/Escritorio-Virtual-SIG-MOBI-1024x576.png"
                    className="attachment-large size-large wp-image-99"
                    alt=""
                    srcSet="https://cdn.sigmobi.com/lpimg/Escritorio-Virtual-SIG-MOBI-1024x576.png 1024w, https://cdn.sigmobi.com/lpimg/Escritorio-Virtual-SIG-MOBI-300x169.png 300w, https://cdn.sigmobi.com/lpimg/Escritorio-Virtual-SIG-MOBI-768x432.png 768w, https://cdn.sigmobi.com/lpimg/Escritorio-Virtual-SIG-MOBI-1536x864.png 1536w, https://cdn.sigmobi.com/lpimg/Escritorio-Virtual-SIG-MOBI-2048x1152.png 2048w"
                    sizes="(max-width: 800px) 100vw, 800px"
                  />{" "}
                </div>
              </div>
              <div
                className="elementor-element elementor-element-6c740df8 elementor-widget elementor-widget-text-editor"
                data-id="6c740df8"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div
                  className="elementor-widget-container"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p>
                    <b>
                      <span style={{ verticalAlign: "inherit" }}>
                        <span style={{ verticalAlign: "inherit" }}> </span>
                      </span>
                    </b>
                  </p>
                  <p style={{ maxWidth: "700px" }}>
                    <strong>
                      <span style={{ color: "#000000" }}>
                        <span
                          style={{
                            textAlign: "center",
                            fontFamily:
                              "var( --e-global-typography-text-font-family ), Sans-serif",
                          }}
                        >
                          <span style={{ color: "#ff0000" }}>
                            <span style={{ verticalAlign: "inherit" }}>
                              <span style={{ verticalAlign: "inherit" }}></span>
                            </span>
                          </span>
                           
                        </span>
                      </span>
                    </strong>
                    <span style={{ fontWeight: "bold" }}>
                      <span style={{ verticalAlign: "inherit" }}>
                        <span style={{ verticalAlign: "inherit" }}>
                          Para ter acesso ao seu Escritório Virtual, basta
                          realizar seu cadastro, baixar o app e fazer login com
                          o e-mail e senha utilizados no cadastro. {"   "}
                        </span>
                      </span>
                    </span>
                    <span style={{ verticalAlign: "inherit" }}>
                      <strong>
                        <span style={{ color: "#000000" }}>
                          <span
                            style={{
                              textAlign: "center",
                              fontFamily:
                                "var( --e-global-typography-text-font-family ), Sans-serif",
                            }}
                          >
                            <span style={{ verticalAlign: "inherit" }}>
                              Lá, você poderá visualizar sua estrutura SIG
                              (pessoas indicadas) e consultar seus relatórios de
                              ganhos.
                            </span>
                          </span>
                        </span>
                      </strong>
                    </span>
                  </p>{" "}
                </div>
              </div>
              <div
                className="elementor-element elementor-element-72efa032 elementor-align-center elementor-widget elementor-widget-button"
                data-id="72efa032"
                data-element_type="widget"
                data-widget_type="button.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-button-wrapper">
                    <a
                      className="elementor-button elementor-button-link elementor-size-sm"
                      href={
                        process.env?.REACT_APP_API_URL ||
                        "https://app.sigmobi.com"
                      }
                    >
                      <span className="elementor-button-content-wrapper">
                        <span className="elementor-button-text">
                          ESCRITÓRIO VIRTUAL
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-19cc2035 elementor-widget elementor-widget-heading"
                data-id="19cc2035"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-large">
                    Nos siga nas redes sociais @sigmobioficial
                  </h2>{" "}
                </div>
              </div>
              <div
                className="elementor-element elementor-element-70b50a34 elementor-shape-circle elementor-grid-mobile-0 elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
                data-id="70b50a34"
                data-element_type="widget"
                data-widget_type="social-icons.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-social-icons-wrapper elementor-grid">
                    <span className="elementor-grid-item">
                      <a
                        className="elementor-icon elementor-social-icon elementor-social-icon-instagram elementor-repeater-item-e08ff74"
                        href="https://www.instagram.com/sigmobioficial"
                        target="_blank"
                      >
                        <span className="elementor-screen-only">Instagram</span>
                        <svg
                          className="e-font-icon-svg e-fab-instagram"
                          viewBox="0 0 448 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                        </svg>{" "}
                      </a>
                    </span>
                    <span className="elementor-grid-item">
                      <a
                        className="elementor-icon elementor-social-icon elementor-social-icon-youtube elementor-repeater-item-74bf42a"
                        href="https://www.youtube.com/@SigMobiOficial"
                        target="_blank"
                      >
                        <span className="elementor-screen-only">Youtube</span>
                        <svg
                          className="e-font-icon-svg e-fab-youtube"
                          viewBox="0 0 576 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path>
                        </svg>{" "}
                      </a>
                    </span>

                    <span className="elementor-grid-item">
                      <a
                        className="elementor-icon elementor-social-icon elementor-social-icon-telegram elementor-repeater-item-telegram"
                        href="https://t.me/SigMobiOficial"
                        target="_blank"
                      >
                        <span className="elementor-screen-only">Telegram</span>
                        <svg
                          className="e-font-icon-svg e-fab-telegram"
                          viewBox="0 0 448 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M446.7 64.6L23.1 216.4c-23.2 9.2-23 10.7-4.1 18.7l111 43.5 42 133c5.3 16.8 8.1 17.4 18.6 8.4l63.8-58.2 106 78.2c19.5 14.6 33.3 7 38.1-16.5L448 82.6c6.4-29.4-9.6-33.4-25.9-18z"></path>
                        </svg>
                      </a>
                    </span>

                    <span className="elementor-grid-item">
                      <a
                        className="elementor-icon elementor-social-icon elementor-social-icon-facebook elementor-repeater-item-facebook"
                        href="https://www.facebook.com/people/Sig-Mobi-Oficial/61563802990531/"
                        target="_blank"
                      >
                        <span className="elementor-screen-only">Facebook</span>
                        <svg
                          className="e-font-icon-svg e-fab-facebook"
                          viewBox="0 0 320 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M279.14 288l14.22-92.66h-88.91V117.21c0-25.35 12.42-50.06 52.24-50.06H293V6.26S273.43 0 248.13 0c-73.36 0-121.42 44.38-121.42 124.72v70.62H56.89V288h69.82v224h92.72V288z"></path>
                        </svg>
                      </a>
                    </span>

                    <span className="elementor-grid-item">
                      <a className="elementor-icon elementor-social-icon elementor-social-icon-tiktok" href="https://www.tiktok.com/@sigmobioficiall" target="_blank">
                        <span className="elementor-screen-only">TikTok</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tiktok" viewBox="0 0 16 16">
                          <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/>
                        </svg>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SectionVirtualOffice;
